import { calculateWorkOrderCosts } from '@calculations/cost/work-order';
import { calculateGrossMarginFromUnitPrice } from '@calculations/price/utilities/gross-margin';

import { storeToCalculationSnapWorkOrder } from '../../transforms/store-to-calculation-snap-work-order';
import { transformWorkOrderCostsToStoreState } from '../../utilities/transform-work-order-costs';
import {
  OnQuantityChangeInput,
  OnQuantityChangeOutput,
  OnUnitPriceChangeInput,
  OnUnitPriceChangeOutput,
  RecalculatePriceStrategy,
} from '../types';

function onQuantityChange({
  quoteLine,
  quantity,
}: OnQuantityChangeInput): OnQuantityChangeOutput {
  if (!quoteLine.snapWorkOrder) {
    return {
      status: 'failure',
      reason: 'No Snap Work Order Found',
    };
  }

  if (!quoteLine.lastWin.hasLastWin) {
    return {
      status: 'failure',
      reason: 'No Last Win Found',
    };
  }

  const costs = calculateWorkOrderCosts({
    quantity,
    ...storeToCalculationSnapWorkOrder(quoteLine.snapWorkOrder),
  });

  return {
    status: 'skip-price',
    ...transformWorkOrderCostsToStoreState(costs),
  };
}

function onUnitPriceChange({
  quotePrice,
  unitPrice,
}: OnUnitPriceChangeInput): OnUnitPriceChangeOutput {
  if (!quotePrice.unitCost) {
    return {
      status: 'failure',
      reason: 'No unit cost found',
    };
  }

  const grossMargin = calculateGrossMarginFromUnitPrice({
    unitCost: quotePrice.unitCost,
    unitPrice,
  });

  return {
    status: 'success',
    grossMargin,
  };
}

export const recalculatePriceSegmentation = {
  onQuantityChange,
  onUnitPriceChange,
  onGrossMarginChange: null,
  onContributionMarginChange: null,
  onBaseGrossMarginChange: null,
  onQuotePriceCreation: null,
  onUnitCostChange: null,
} satisfies RecalculatePriceStrategy;
